import { gql } from '@apollo/client';
import { UserRole, UserStatus } from '../../__generated__/graphql';

export interface User {
  _id: string,
  companyId: string,
  firstname: string,
  lastname: string,
  fullname: string,
  title: string,
  email: string,
  role: UserRole,
  status: UserStatus,
  company: {
    name: string
  }
  __typename: 'User'
}

export const CURRENT_USER_QUERY = gql`
  query me {
    CurrentUser {
      _id
      fullname
      firstname
      lastname
      email
      title
      role
      companyId
      avatarUrl @client
      company {
        _id
        name
        type
        slug
        allowedMarketplaces
        allowMarketplaceCampaigns
        allowFillerCampaigns
        allowInHouseCampaigns
        allowMarketplaceNativeCampaigns
        allowInHouseNativeCampaigns
        allowVevIntegration
        allowMarketplaceCpa
        allowTeaserVideos
        allowTeaserRibbon
        allowPreferredDeals
        allowedTeaserFormats {
          type
          displayName
          minImageSize {
            width
            height
          }
          recommendedAspectRatio
          cloudinaryTransform
        }
        targetingSections
        v2migration
      }
    }
  }
`;

const user = `
  _id
  firstname
  lastname
  fullname
  title
  email
  role
  status
  allowPasswordLogin
  company {
    name
  }
`
export const CREATE_USER = gql`
  mutation CreateUser($record: CreateUserInput!) {
    UserCreateOne(record: $record) {
      ${user}
    }
  }
`

export const GET_USERS = gql`
query UserMany($page: Int, $perPage: Int, $filters: UserFilterArgs!) {
  users: UserMany(page: $page, perPage: $perPage, filters: $filters) {
      items {
        ${user}
      }
      meta {
        totalPages
        totalItems
      }
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser($id: ObjectId!, $record: UpdateUserInput!) {
    UserUpdateById(_id: $id, record: $record) {
      ${user}
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($id: ObjectId!){
    UserDeleteById(_id: $id)
  }
`

export const GET_COMPANY_USERS = gql`
  query UserMany($perPage: Int, $filters: UserFilterArgs!) {
    users: UserMany(perPage: $perPage, filters: $filters) {
        items {
          value: _id
          label: email
          role
        }
      }
    }
`
